import axios from "axios";
import { getRefreshToken, saveToken, clearOnLogout, env } from "@/lib/utils";
import toast from "@/lib/toast";

export const refreshAccessToken = async () => {
  try {
    const refreshToken = getRefreshToken();

    const response = await axios.post(
      `${String(env("VITE_API_BASE_URL"))}/api/token`,
      { token: refreshToken },
    );

    const newAccessToken = response.data?.data?.accessToken;

    if (!newAccessToken) {
      throw new Error("No access token returned");
    }

    saveToken(newAccessToken);

    return newAccessToken;
  } catch (error) {
    clearOnLogout();
    toast.error("Session expired. Please login again.");
    throw error;
  }
};
